<template>
    <div>
    
        <not-allowed v-if="!AllowedDisplay" :page="page" :module="idmodule" :data="datas"></not-allowed>
    <v-scale-transition>

    <div v-show="show">

        </div>
    
    </v-scale-transition>
    </div>
    </template>
    
    
    
    <script>

import { EventBus } from '@/services/EventBus';
import { client } from '../mixins';
        export default {

            mixins : [client],
            name : 'FrontDatasModule',
            inject: { chatResourceEmbedded: { default: false } },
            data: function() {
    
                return {
                    AllowedDisplay : true,
                    show : false,
                    pdfUrl : '',
                    datas : [],
                    params:{},
                    querys: {},
                    parentModal : this.$store.getters.modalShowParams({ type: 'current', val: this.modalKey })['parent'],
                    searchmodule : [],
                }
            },

        computed : {
            isNewFilterOnModal() {
            return (this.$store.getters.modalShowParams({ type: 'current', val: this.parentModal })) ? this.$store.getters.modalShowParams({ type: 'current', val: this.parentModal }).query : this.$route.query;
            }
        },

        watch : {

            isNewFilterOnModal(val, oldVal) {
                const keys = new Set([...Object.keys(val || {}), ...Object.keys(oldVal || {})]);
                const changed = [...keys].some(key => this.searchmodule.some(id => key.startsWith(id + '_'))
                    && JSON.stringify((val || {})[key]) !== JSON.stringify((oldVal || {})[key]));
                if(changed) {
                    this.querys = val || {}
                    this.callAPI();
                }

            },

        },

            methods :  {    
                callAPI : function() {
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:this.params,querys:this.querys}}).then((resp) => {

                        this.manageDatas(resp.data)
                            
                    })
    
                },  

                manageDatas(data) {
                    if(!data.success) {
                            this.AllowedDisplay = false; 
                            return false;
                            }
                            if(this._isBeingDestroyed || this._isDestroyed) return
                            this.$store.dispatch('setFrontDatas',{datas:data.datas,module:this.idmodule,page:this.chatResourceEmbedded ? this.modalKey : undefined});
                            let aa = {}
                            this.searchmodule = data.searchmodule;
                            aa[this.idmodule] = data.datas
                            console.log('emit lancé')
                            EventBus.$emit(this.chatResourceEmbedded ? `setFrontDatas:${this.modalKey}` : 'setFrontDatas',aa);
                            this.show = true 
                },
                
                initiateParams() {
                this.params = this.$store.getters.specificPage(this.modalKey).params    
                this.querys = this.$route.query
                if(this.customparams) this.params = this.customparams
                },   

            },
    
            created() {  
                this.initiateParams()
                let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.callAPI() 
                } 
            },

            mounted() {

            }
    
        }
    
    </script>
